module.exports = __webpack_public_path__ + "img/Bar@3x.d1fcab3c.png";